import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import Logo from "@/components/Logo";

export const H = ({ children }) => <h2 className="mt-8 font-display text-lg font-700 text-[hsl(var(--gold))] md:text-lg">{children}</h2>;
export const P = ({ children }) => <p className="mt-2 text-sm leading-relaxed text-slate-300">{children}</p>;

export function usePublicInfo() {
  const [info, setInfo] = useState({ contact_email: "", organisation: "Brothers Across Nigeria Int'l — IOTA Galleon", app: "IOTA Private Vessel", updated_at: "" });
  useEffect(() => { axios.get(`${API}/public/info`).then((r) => setInfo(r.data)).catch(() => {}); }, []);
  return info;
}

// Shared shell for the public legal/help pages (/privacy, /support, /leave)
export default function PublicShell({ eyebrow, title, subtitle, testid, children }) {
  return (
    <div className="min-h-screen bg-[#0A192F] text-white" data-testid={testid}>
      <div className="mx-auto max-w-3xl px-6 py-12">
        <div className="flex items-center justify-between"><Logo /><Link to="/login" className="text-xs text-[hsl(var(--gold))] hover:underline" data-testid={`${testid}-back-login`}>Sign in</Link></div>
        <p className="label-eyebrow mt-10">{eyebrow}</p>
        <h1 className="mt-2 font-display text-4xl font-800 sm:text-5xl">{title}</h1>
        {subtitle && <p className="mt-3 text-sm text-slate-400">{subtitle}</p>}
        {children}
        <p className="mt-10 flex flex-wrap gap-4 text-xs text-slate-500">
          <Link to="/privacy" className="hover:text-slate-300" data-testid={`${testid}-link-privacy`}>Privacy Policy</Link>
          <Link to="/support" className="hover:text-slate-300" data-testid={`${testid}-link-support`}>Help &amp; Support</Link>
          <Link to="/leave" className="hover:text-slate-300" data-testid={`${testid}-link-leave`}>Delete my account</Link>
        </p>
      </div>
    </div>
  );
}
